import { render, staticRenderFns } from "./ViewAccount.vue?vue&type=template&id=9513af52&scoped=true&"
import script from "./ViewAccount.vue?vue&type=script&lang=js&"
export * from "./ViewAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9513af52",
  null
  
)

export default component.exports